import { createSlice } from '@reduxjs/toolkit';
//import { handleGetJobDetails, handleGetOverviewJobDetails } from './jobDetailsThunk';
//import { IJobDetails, IOverviewJobDetails } from '~/utils/interface/jobDetails';
import { handleDeleteEstimate, handleDeletePhoto, handleGetPhoto, handleUpdatePhoto, handleUploadPhotos } from '../job/jobThunk';
import { handleGetInvoiceJobDetailsList, handleGetJobDetails, handleGetListBudgetTrackerJobDetails, handleGetListCreditMemoJobDetails, handleGetOverviewActivityFeed, handleGetOverviewCustomerDetails, handleGetOverviewJobDetails, handleGetOverviewJobTaskList, handleGetOverviewWorkOrderList, handleGetPaymentJobDetailsList, handleToggleArchivedBudgetTracker, handleUpdateOverviewJobDetails } from './jobDetailsThunk';
import { IBudgetTrackerJobDetailsListResponse, ICreditMemoJobDetailsListResponse, IInvoiceJobDetailsListResponse, IJobDetails, IOverviewActivityFeed, IOverviewCustomerDetails, IOverviewJobDetails, IOverviewJobTaskListResponse, IOverviewWorkOrderListResponse, IPaymentJobDetailsListResponse } from '~/utils/interface/jobDetails';

export interface JobDetailsState {
  jobDetails: IJobDetails | null;
  isLoadingJobDetails: boolean;
  errorJobDetails: string | null;
  overviewJobDetails: IOverviewJobDetails | null;
  isLoadingOverviewJobDetails: boolean;
  timeUpdatePhoto: number,
  isUpdatingOverviewJobDetails: boolean;
  overviewCustomerDetails: IOverviewCustomerDetails | null;
  isLoadingOverviewCustomerDetails: boolean;
  overviewActivityFeed: IOverviewActivityFeed[] | [];
  isLoadingOverviewActivityFeed: boolean;
  isUpdatingJobDetails: boolean;
  overviewWorkOrderList: IOverviewWorkOrderListResponse | null;
  isLoadingOverviewWorkOrderList: boolean;
  overviewJobTaskList: IOverviewJobTaskListResponse | null;
  isLoadingOverviewJobTaskList: boolean;
  invoiceJobDetailsList: IInvoiceJobDetailsListResponse | null;
  isLoadingInvoiceJobDetailsList: boolean;
  paymentJobDetailsList: IPaymentJobDetailsListResponse | null;
  isLoadingPaymentJobDetailsList: boolean;
  budgetTrackerJobDetailsList: IBudgetTrackerJobDetailsListResponse | null;
  isLoadingBudgetTrackerJobDetailsList: boolean;
  creditMemoJobDetailsList: ICreditMemoJobDetailsListResponse | null;
  isLoadingCreditMemoJobDetailsList: boolean;
}

const initialState: JobDetailsState = {
  jobDetails: null,
  isLoadingJobDetails: false,
  errorJobDetails: null,
  overviewJobDetails: null,
  isLoadingOverviewJobDetails: false,
  timeUpdatePhoto: 1,
  isUpdatingOverviewJobDetails: false,
  overviewCustomerDetails: null,
  isLoadingOverviewCustomerDetails: false,
  overviewActivityFeed: [],
  isLoadingOverviewActivityFeed: false,
  isUpdatingJobDetails: false,
  overviewWorkOrderList: null,
  isLoadingOverviewWorkOrderList: false,
  overviewJobTaskList: null,
  isLoadingOverviewJobTaskList: false,
  invoiceJobDetailsList: null,
  isLoadingInvoiceJobDetailsList: false,
  paymentJobDetailsList: null,
  isLoadingPaymentJobDetailsList: false,
  budgetTrackerJobDetailsList: null,
  isLoadingBudgetTrackerJobDetailsList: false,
  creditMemoJobDetailsList: null,
  isLoadingCreditMemoJobDetailsList: false,
};

const jobDetailsSlice = createSlice({
  name: 'jobDetails',
  initialState,
  reducers: {
    resetJobDetailsState: () => initialState,
  },
  extraReducers(builder) {
    builder
      // Get Job Details
      .addCase(handleGetJobDetails.pending, (state) => {
        state.isLoadingJobDetails = true;
        state.errorJobDetails = null;
      })
      .addCase(handleGetJobDetails.fulfilled, (state, action) => {
        state.jobDetails = action.payload.data;
        state.isLoadingJobDetails = false;
        state.errorJobDetails = null;
      })
      .addCase(handleGetJobDetails.rejected, (state, action) => {
        state.isLoadingJobDetails = false;
        state.jobDetails = null;
        state.overviewJobDetails = null;
        state.isLoadingOverviewJobDetails = false;
        state.isLoadingOverviewCustomerDetails = false;
        state.isLoadingOverviewActivityFeed = false;
        const status = action.payload?.status;
        const message = action.payload?.message;
        state.errorJobDetails =
          status === 404 || message?.toLowerCase().includes('not found')
            ? "Job doesn't exist"
            : message || action.error.message || 'Failed to fetch job details';
      })

      // Get Overview Job Details
      .addCase(handleGetOverviewJobDetails.pending, (state) => {
        state.isLoadingOverviewJobDetails = true;
      })
      .addCase(handleGetOverviewJobDetails.fulfilled, (state, action) => {
        state.overviewJobDetails = action.payload.data;
        state.isLoadingOverviewJobDetails = false;
      })
      .addCase(handleGetOverviewJobDetails.rejected, (state) => {
        state.isLoadingOverviewJobDetails = false;
      })
      .addCase(handleUploadPhotos.pending, (state) => {
        state.isUpdatingJobDetails = true;
      })
      .addCase(handleUploadPhotos.fulfilled, (state) => {
        state.timeUpdatePhoto = new Date().getTime();
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleUploadPhotos.rejected, (state) => {
        state.isUpdatingJobDetails = false;
      })

      .addCase(handleGetPhoto.pending, (state) => {
        state.isUpdatingJobDetails = true;
      })
      .addCase(handleGetPhoto.fulfilled, (state) => {
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleGetPhoto.rejected, (state) => {
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleUpdatePhoto.pending, (state) => {
        state.isUpdatingJobDetails = true;
      })
      .addCase(handleUpdatePhoto.fulfilled, (state) => {
        state.timeUpdatePhoto = new Date().getTime();
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleUpdatePhoto.rejected, (state) => {
        state.isUpdatingJobDetails = false;
      })

      .addCase(handleDeletePhoto.pending, (state) => {
        state.isUpdatingJobDetails = true;
      })
      .addCase(handleDeletePhoto.fulfilled, (state) => {
        state.timeUpdatePhoto = new Date().getTime();
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleDeletePhoto.rejected, (state) => {
        state.isUpdatingJobDetails = false;
      })

      //estimate
      .addCase(handleDeleteEstimate.pending, (state) => {
        state.isUpdatingJobDetails = true;
      })
      .addCase(handleDeleteEstimate.fulfilled, (state) => {
        state.isUpdatingJobDetails = false;
      })
      .addCase(handleDeleteEstimate.rejected, (state) => {
        state.isUpdatingJobDetails = false;
      })


      // Update Overview Job Details
      .addCase(handleUpdateOverviewJobDetails.pending, (state) => {
        state.isUpdatingOverviewJobDetails = true;
      })
      .addCase(handleUpdateOverviewJobDetails.fulfilled, (state, action) => {
        const updatedOverview = action.payload.data;
        state.overviewJobDetails = updatedOverview;

        if (state.jobDetails && updatedOverview) {
          state.jobDetails = {
            ...state.jobDetails,
            name: updatedOverview.title,
            jobId: updatedOverview.jobUniqueID,
          };
        }

        state.isUpdatingOverviewJobDetails = false;
      })
      .addCase(handleUpdateOverviewJobDetails.rejected, (state) => {
        state.isUpdatingOverviewJobDetails = false;
      })

      // Get Overview Customer Details
      .addCase(handleGetOverviewCustomerDetails.pending, (state) => {
        state.isLoadingOverviewCustomerDetails = true;
      })
      .addCase(handleGetOverviewCustomerDetails.fulfilled, (state, action) => {
        state.overviewCustomerDetails = action.payload.data;
        state.isLoadingOverviewCustomerDetails = false;
      })
      .addCase(handleGetOverviewCustomerDetails.rejected, (state) => {
        state.isLoadingOverviewCustomerDetails = false;
      })

      // Get Overview Activity Feed
      .addCase(handleGetOverviewActivityFeed.pending, (state) => {
        state.isLoadingOverviewActivityFeed = true;
      })
      .addCase(handleGetOverviewActivityFeed.fulfilled, (state, action) => {
        state.overviewActivityFeed = action.payload.data;
        state.isLoadingOverviewActivityFeed = false;
      })
      .addCase(handleGetOverviewActivityFeed.rejected, (state) => {
        state.isLoadingOverviewActivityFeed = false;
      })

      // Get Overview Work Order List
      .addCase(handleGetOverviewWorkOrderList.pending, (state) => {
        state.isLoadingOverviewWorkOrderList = true;
      })
      .addCase(handleGetOverviewWorkOrderList.fulfilled, (state, action) => {
        state.overviewWorkOrderList = action.payload.data;
        state.isLoadingOverviewWorkOrderList = false;
      })
      .addCase(handleGetOverviewWorkOrderList.rejected, (state) => {
        state.isLoadingOverviewWorkOrderList = false;
      })

      // Get Overview Job Task List
      .addCase(handleGetOverviewJobTaskList.pending, (state) => {
        state.isLoadingOverviewJobTaskList = true;
      })
      .addCase(handleGetOverviewJobTaskList.fulfilled, (state, action) => {
        state.overviewJobTaskList = action.payload.data;
        state.isLoadingOverviewJobTaskList = false;
      })
      .addCase(handleGetOverviewJobTaskList.rejected, (state) => {
        state.isLoadingOverviewJobTaskList = false;
      })

      // Get Invoice Job Details List
      .addCase(handleGetInvoiceJobDetailsList.pending, (state) => {
        state.isLoadingInvoiceJobDetailsList = true;
      })
      .addCase(handleGetInvoiceJobDetailsList.fulfilled, (state, action) => {
        state.invoiceJobDetailsList = action.payload.data;
        state.isLoadingInvoiceJobDetailsList = false;
      })
      .addCase(handleGetInvoiceJobDetailsList.rejected, (state) => {
        state.isLoadingInvoiceJobDetailsList = false;
      })

      // Get Payment Job Details List
      .addCase(handleGetPaymentJobDetailsList.pending, (state) => {
        state.isLoadingPaymentJobDetailsList = true;
      })
      .addCase(handleGetPaymentJobDetailsList.fulfilled, (state, action) => {
        state.paymentJobDetailsList = action.payload.data;
        state.isLoadingPaymentJobDetailsList = false;
      })
      .addCase(handleGetPaymentJobDetailsList.rejected, (state) => {
        state.isLoadingPaymentJobDetailsList = false;
      })

      // Get Budget Tracker Job Details List
      .addCase(handleGetListBudgetTrackerJobDetails.pending, (state) => {
        state.isLoadingBudgetTrackerJobDetailsList = true;
      })
      .addCase(handleGetListBudgetTrackerJobDetails.fulfilled, (state, action) => {
        state.budgetTrackerJobDetailsList = action.payload.data;
        state.isLoadingBudgetTrackerJobDetailsList = false;
      })
      .addCase(handleGetListBudgetTrackerJobDetails.rejected, (state) => {
        state.isLoadingBudgetTrackerJobDetailsList = false;
      })

      // Get Credit Memo Job Details List
      .addCase(handleGetListCreditMemoJobDetails.pending, (state) => {
        state.isLoadingCreditMemoJobDetailsList = true;
      })
      .addCase(handleGetListCreditMemoJobDetails.fulfilled, (state, action) => {
        state.creditMemoJobDetailsList = action.payload.data;
        state.isLoadingCreditMemoJobDetailsList = false;
      })
      .addCase(handleGetListCreditMemoJobDetails.rejected, (state) => {
        state.isLoadingCreditMemoJobDetailsList = false;
      })

      .addCase(handleToggleArchivedBudgetTracker.fulfilled, (state, action) => {
        const { idBudget } = action.meta.arg;
        const responses = state.budgetTrackerJobDetailsList?.responses;
        if (responses) {
          const budget = responses.find((b: { id: string }) => b.id === idBudget);
          if (budget) {
            budget.isArchived = !budget.isArchived;
          }
        }
      })
  },
});

export const jobDetailsActions = jobDetailsSlice.actions;

const jobDetailsReducer = jobDetailsSlice.reducer;
export default jobDetailsReducer;